import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import { ConditionalComponent } from 'components/ConditionalWrappers/ConditionalComponentWrapper/ConditionalComponent';
import {
  ACTIONS_TAB_VALUE,
  AI_TOOLS_TAB_VALUE,
  GROUP_TAB_VALUE,
  SLIDE_METADATA_TAB_VALUE,
} from 'components/PathologyMap/constants/common';
import { SlideGroupsVerticalContainer } from 'components/SlideGroups/Modals/components/SlideGroupsVerticalContainer';
import { Actions } from 'components/PathologyMap/Modals/FullSlideInfoModal/SlideInfoSection/Actions';
import { SlideMetadata } from 'components/OrderSlidesList/SlideActionTabs/SlideMetadata/SlideMetadata';
import { SlideAiToolsWrapper } from 'components/AITools/components/SlideAiToolsWrapper';
import { useDispatch, useSelector } from 'react-redux';
import {
  isExpandedBottomSelector,
  setExpanded,
} from 'store/slices/slidesListSlice/slidesListSlice';

export const SlideInfoCardContent = ({ classes, currentTabValue, slide }) => {
  const dispatch = useDispatch();
  const isExpandedBottom = useSelector(isExpandedBottomSelector);
  const isAITools = currentTabValue === AI_TOOLS_TAB_VALUE;

  useEffect(() => {
    if (isExpandedBottom && !isAITools) {
      dispatch(setExpanded({ isExpanded: false, isTop: false }));
    }
  }, [dispatch, isExpandedBottom, isAITools]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      height="calc(100% - 60px)"
      paddingX={isAITools ? '0px' : '1rem'}
    >
      <ConditionalComponent
        condition={currentTabValue === SLIDE_METADATA_TAB_VALUE}
      >
        <Box className={classes.slideInfoTabContent}>
          <SlideMetadata slide={slide} isSlideCard />
        </Box>
      </ConditionalComponent>
      <ConditionalComponent condition={currentTabValue === GROUP_TAB_VALUE}>
        <SlideGroupsVerticalContainer
          selectedSlides={[slide]}
          customClasses={classes}
          showCreateButton
        />
      </ConditionalComponent>
      <ConditionalComponent
        condition={currentTabValue === AI_TOOLS_TAB_VALUE}
      >
        <SlideAiToolsWrapper slide={slide} isExpanded={isExpandedBottom} />
      </ConditionalComponent>
      <ConditionalComponent condition={currentTabValue === ACTIONS_TAB_VALUE}>
        <Box padding={1}>
          <Actions currentSlide={slide} classes={classes} />
        </Box>
      </ConditionalComponent>
    </Box>
  );
};
